<template>
  <div class="c-searchBudget">
    <c-select
      v-model="innerValue"
      size="is-medium"
      expanded
    >
      <option :value="null">指定なし</option>
      <option
        v-for="requestPrice in prices"
        :value="requestPrice"
        :key="requestPrice"
      >{{ requestPriceText(requestPrice) }}</option>
    </c-select>
  </div>
</template>
<script>
// vuex
import { mapState } from 'vuex'

export default {
  name: 'SearchBudget',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    prices: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState('master', ['requestPrices']),
    innerValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    requestPriceText(price) {
      return this.$util.numberWithDelimiter(Number(price)) + '円'
    }
  }
}
</script>

<style lang="scss" scoped>
.c-searchBudget {
  /deep/ .select {
    select {
      padding-left: 8px;
      white-space: nowrap;
    }
  }
}
</style>
